/**
 * Session API
 * Handles session creation and management
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseAPI } from "./base-api";
export class SessionAPI extends BaseAPI {
    /**
     * Create a new chat session
     */
    createSession() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.post(`${this.env.AGENT_BASE_URL}/apps/consumer/users/${this.userId}/sessions`, {});
                return data.id;
            }
            catch (error) {
                console.error("Error creating session:", error);
                throw error;
            }
        });
    }
    /**
     * Get all sessions for a user
     */
    getUserSessions() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.get(`${this.env.AGENT_BASE_URL}/sessions/${this.userId}`);
                return data;
            }
            catch (error) {
                console.error("Error fetching user sessions:", error);
                throw error;
            }
        });
    }
    /**
     * Get conversation messages for a session
     */
    getConversation(sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.get(`${this.env.AGENT_BASE_URL}/conversations/${this.userId}/${sessionId}`);
                return data;
            }
            catch (error) {
                console.error("Error fetching conversation:", error);
                throw error;
            }
        });
    }
    /**
     * Delete a chat session
     */
    deleteSession(sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.delete(`${this.env.AGENT_BASE_URL}/sessions/${this.userId}/${sessionId}`);
            }
            catch (error) {
                console.error("Error deleting session:", error);
                throw error;
            }
        });
    }
}
